import { FactoryTypes, FieldID, GuideContent, GuideTypes } from "../models";
import { FlowTypes, MobileDeviceValues } from "@trailhead/smart-setup-core";
import {
  androidToiPhoneSetupLostPhone,
  androidToSamsungSetupLostPhone,
  androidToSamsungSetupWithPhone,
  backupAndroidContent,
  backupIphone,
  iphoneSetupContentWithPhone,
  iphoneToAndroidSetupWithPhone,
  iphoneToIphoneSetupLostPhone,
  iphoneToIphoneSetupWithPhone,
  iphoneToSamsungSetupWithPhone,
  samsungToAndroidLostPhone,
  samsungToAndroidWithPhone,
  telusKoodoIphoneToAndroidSetupLostPhone,
  telusKoodoIphoneToSamsungSetupLostPhone,
} from "./common";
import { FieldMappingContainer } from "../types";

export const telusKoodoIPhoneSendBackContent = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.tipTelusReturnOldDevice,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.stepSendUsYourIPhone.text,
    },
  },
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.simBatteryOrSDCardNotAccessible,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.stepDisableFindMyIphone.text,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      yesButtonText: FieldID.guideContainer.decisionStep.introHeaderGuideIos13,
      noButtonText: FieldID.guideContainer.decisionStep.headerGuideOlderIos,
      buttonVariant: "flat",
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.stepOpenIphoneSettings.text,
            image: FieldID.guideContainer.steps.stepOpenIphoneSettings.image,
            shouldInlineTextAndImage: true,
          },
        },
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.stepSettingsTapYourName.text,
            shouldInlineTextAndImage: true,
          },
        },
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.stepFindMyIcon.text,
            image: FieldID.guideContainer.steps.stepFindMyIcon.image,
            shouldInlineTextAndImage: true,
          },
        },
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.stepFindMyIphoneOffOn.text,
            shouldInlineTextAndImage: true,
          },
        },
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.stepFindMyIphoneToggleSwitch
              .text,
            image:
              FieldID.guideContainer.steps.stepFindMyIphoneToggleSwitch.image,
            shouldInlineTextAndImage: true,
          },
        },
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.stepAppleIdPasswordTurnOff.text,
            image:
              FieldID.guideContainer.steps.stepAppleIdPasswordTurnOff.image,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.stepOpenIphoneSettings.text,
            image: FieldID.guideContainer.steps.stepOpenIphoneSettings.image,
            shouldInlineTextAndImage: true,
          },
        },
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.stepSettingsTapYourName.text,
            shouldInlineTextAndImage: true,
          },
        },
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.turnOffFindMyPhone.text,
            image: FieldID.guideContainer.steps.turnOffFindMyPhone.image,
            shouldInlineTextAndImage: true,
          },
        },
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.turnOffIPhoneStep.text,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.placeOriginalDeviceInPrepaid.text,
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.filedServiceRequestLostStolenDevice
        .text,
    },
  },
  {
    type: FactoryTypes.EXPERT_HELP,
    fieldMapping: {
      buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
      title: FieldID.guideContainer.expertHelpContent.title,
      subtext: FieldID.guideContainer.expertHelpContent.subtext,
      secondaryButtonText:
        FieldID.guideContainer.expertHelpContent.secondaryButtonText,
      supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
    },
  },
];

export const telusKoodoSendBackContent = {
  criteria: {
    oldDeviceAccess: true,
    deviceFlowType: FlowTypes.Replacement,
  },
  content: [
    {
      type: FactoryTypes.TIPBOX,
      fieldMapping: {
        text: FieldID.guideContainer.tipBox.tipTelusReturnOldDevice,
        icon: FieldID.guideContainer.tipBox.icon,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.removeSimCardAndBattery.text,
      },
    },
    {
      type: FactoryTypes.TIPBOX,
      fieldMapping: {
        text: FieldID.guideContainer.tipBox.simBatteryOrSDCardNotAccessible,
        icon: FieldID.guideContainer.tipBox.icon,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.placeOriginalDeviceInPrepaid.text,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.filedServiceRequestLostStolenDevice
          .text,
      },
    },
    {
      type: FactoryTypes.EXPERT_HELP,
      fieldMapping: {
        buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
        title: FieldID.guideContainer.expertHelpContent.title,
        subtext: FieldID.guideContainer.expertHelpContent.subtext,
        secondaryButtonText:
          FieldID.guideContainer.expertHelpContent.secondaryButtonText,
        supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
      },
    },
  ],
};

export const telusKoodoActivationContentIPhoneToAndroid = (
  additionalSteps?: FieldMappingContainer<GuideContent>[],
) => [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.commonActivateIMessageTipBox,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.GUIDE_INTRO,
    fieldMapping: {
      text: FieldID.guideContainer.introduction.text,
    },
  },
  {
    type: FactoryTypes.POPUP,
    fieldMapping: {
      buttonText: FieldID.guideContainer.simCardExplanation.questionText,
      popupTitleText: FieldID.guideContainer.simCardExplanation.questionText,
      popupDescriptionText:
        FieldID.guideContainer.simCardExplanation.descriptionText,
      popupImageDescriptionText:
        FieldID.guideContainer.simCardExplanation.imageDescription,
      popupImage: FieldID.guideContainer.simCardExplanation.image,
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.powerOffNewPhoneStep.text,
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.locateSimCardTrayStep.text,
      image: FieldID.guideContainer.steps.locateSimCardTrayStep.image,
    },
  },
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.insertNewSimCard.text,
    },
  },
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.simCardCautionText,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.STEP,
    fieldMapping: {
      image: FieldID.guideContainer.steps.insertNewSimCard.image,
    },
  },
  ...(additionalSteps || []),
  {
    type: FactoryTypes.EXPERT_HELP,
    fieldMapping: {
      buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
      title: FieldID.guideContainer.expertHelpContent.title,
      subtext: FieldID.guideContainer.expertHelpContent.subtext,
    },
  },
];

export const telusKoodoActivationContent = (
  additionalSteps?: FieldMappingContainer<GuideContent>[],
) => ({
  criteria: { newDeviceActivated: false },
  content: [
    {
      type: FactoryTypes.GUIDE_INTRO,
      fieldMapping: {
        text: FieldID.guideContainer.introduction.text,
      },
    },
    {
      type: FactoryTypes.POPUP,
      fieldMapping: {
        buttonText: FieldID.guideContainer.simCardExplanation.questionText,
        popupTitleText: FieldID.guideContainer.simCardExplanation.questionText,
        popupDescriptionText:
          FieldID.guideContainer.simCardExplanation.descriptionText,
        popupImageDescriptionText:
          FieldID.guideContainer.simCardExplanation.imageDescription,
        popupImage: FieldID.guideContainer.simCardExplanation.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.powerOffNewPhoneStep.text,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.locateSimCardTrayStep.text,
        image: FieldID.guideContainer.steps.locateSimCardTrayStep.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.insertNewSimCard.text,
      },
    },
    {
      type: FactoryTypes.TIPBOX,
      fieldMapping: {
        text: FieldID.guideContainer.tipBox.simCardCautionText,
        icon: FieldID.guideContainer.tipBox.icon,
      },
    },
    {
      type: FactoryTypes.STEP,
      fieldMapping: {
        image: FieldID.guideContainer.steps.insertNewSimCard.image,
      },
    },
    ...(additionalSteps || []),
    {
      type: FactoryTypes.EXPERT_HELP,
      fieldMapping: {
        buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
        title: FieldID.guideContainer.expertHelpContent.title,
        subtext: FieldID.guideContainer.expertHelpContent.subtext,
      },
    },
  ],
});

const telusActivationStep = {
  type: FactoryTypes.NUMBERED_STEP,
  fieldMapping: {
    text: FieldID.guideContainer.steps.telusPhoneActivationStep.text,
  },
};

export const TelusContent = {
  [GuideTypes.BACKUP]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
      },
      content: backupIphone,
    },
    backupAndroidContent(MobileDeviceValues.Samsung),
    backupAndroidContent(MobileDeviceValues.OtherAndroid),
    backupAndroidContent(MobileDeviceValues.Pixel),
  ],
  [GuideTypes.ACTIVATE]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.OtherAndroid,
        newDeviceActivated: false,
      },
      content: telusKoodoActivationContentIPhoneToAndroid([
        telusActivationStep,
      ]),
    },
    telusKoodoActivationContent([telusActivationStep]),
  ],
  [GuideTypes.SETUP]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: true,
      },
      content: iphoneToIphoneSetupWithPhone,
    }, //iphone to iphone with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: false,
      },
      content: iphoneToIphoneSetupLostPhone,
    },
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: true,
      },
      content: iphoneToSamsungSetupWithPhone,
    }, //iphone to samsung with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: false,
      },
      content: telusKoodoIphoneToSamsungSetupLostPhone,
    }, //iphone to samsung lost phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: true,
      },
      content: iphoneToAndroidSetupWithPhone,
    }, //iphone to android with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: false,
      },
      content: telusKoodoIphoneToAndroidSetupLostPhone,
    }, //iphone to android lost phone

    //--------------------------------------------

    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: true,
      },
      content: androidToSamsungSetupWithPhone,
    }, //samsung to samsung with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: true,
      },
      content: iphoneSetupContentWithPhone,
    }, //samsung to iphone with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: true,
      },
      content: samsungToAndroidWithPhone,
    }, //samsung to android with phone

    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: true,
      },
      content: iphoneSetupContentWithPhone,
    }, //android to iphone with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: true,
      },
      content: androidToSamsungSetupWithPhone,
    }, //android to samsung with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: true,
      },
      content: samsungToAndroidWithPhone,
    }, //android to android with phone

    {
      criteria: {
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: false,
      },
      content: androidToiPhoneSetupLostPhone,
    }, //x to iphone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: false,
      },
      content: androidToSamsungSetupLostPhone,
    }, //android to samsung WITHOUT phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: false,
      },
      content: androidToSamsungSetupLostPhone,
    }, //samsung to samsung WITHOUT phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: false,
      },
      content: samsungToAndroidLostPhone,
    }, //samsung to android WITHOUT phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: false,
      },
      content: samsungToAndroidLostPhone,
    }, //android to android WITHOUT phone
  ],
  [GuideTypes.SEND_BACK]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        oldDeviceAccess: true,
        deviceFlowType: FlowTypes.Replacement,
      },
      content: telusKoodoIPhoneSendBackContent,
    },
    telusKoodoSendBackContent,
  ],
};
